module.exports = __webpack_public_path__ + "img/facebook.210f2fdb.svg";